import React, { useEffect, useMemo, useState } from 'react'

import TextField from '@material-ui/core/TextField'
import EditIcon from '@material-ui/icons/Edit'
import { Type } from '../../../../../../../store/constants/type'
import { makeStyles } from '@material-ui/core'
import { FonctionPopperDefinition } from './fonction-popper-definition'
import { getFonctionAsSTR } from './parameter-field'

const useStyles = makeStyles(theme => ({
  contentRoot: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  popper: {
    ...theme.mixins.gutters(),
    minWidth: 380,
    maxWidth: 600,
    margin: 'auto',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
  },
  container: { maxWidth: '80%', overflowX: 'hidden', margin: 'auto', marginTop: 16 },
  container2: { maxWidth: '80%', overflowX: 'hidden', marginTop: 16 },
  formControl: {
    margin: 0,
    marginTop: 16,
    width: '100%',
  },
  area: {
    '&:focus-visible': {
      border: '#3f51b5 solid',
    },
  },
}))

export function exceedMaxChar(text) {
  return text && text.length > 30
}

export function FunctionCellType({
  component,
  compValue,
  tooltipContent,
  cellEditMode,
  lineEditMode,
  editValue,
  editDataTest,
  setTmpData,
  line,
}) {
  const [tmpValue, setTmpValue] = useState(cellEditMode && !lineEditMode ? editValue : compValue)
  const [anchorEl, setAnchorEl] = useState()
  const [fonctionParams, setFonctionParams] = useState()
  const classes = useStyles()

  useEffect(() => {
    setTmpValue(cellEditMode ? editValue : compValue)
  }, [editValue, compValue, cellEditMode])

  useEffect(() => {
    if (lineEditMode) setTmpValue(compValue)
  }, [lineEditMode])

  useEffect(() => {
    {
      tooltipContent(component.type.name === Type.TEXT.name && exceedMaxChar(compValue) ? <div>{compValue}</div> : '')
    }
  }, [compValue])

  function handleChange(value) {
    const toSave = value
    setTmpValue(toSave)
    setTmpData(component.nom, toSave, component)
  }

  function handleEdit(event) {
    setAnchorEl(event.currentTarget)
  }

  function getEditIcon() {
    return <EditIcon fontSize={'small'} onClick={handleEdit} data-test="EDIT" style={{ cursor: 'pointer' }} />
  }

  const open = Boolean(anchorEl)

  useEffect(() => {
    const handleEsc = event => {
      console.log('key', event.key)
      event.key === 'Escape' && setAnchorEl(null)
      event.stopPropagation()
    }
    if (open) {
      console.log('add esc listener')
      window.addEventListener('keyup', handleEsc)
    }

    return () => window.removeEventListener('keyup', handleEsc)
  }, [open])

  let fonctionAsSTR = useMemo(() => getFonctionAsSTR(tmpValue), [tmpValue])
  return (
    <>
      {!cellEditMode ? (
        fonctionAsSTR
      ) : (
        <TextField
          data-test={editDataTest + '_edit'}
          type={'text'}
          value={fonctionAsSTR}
          disabled
          label={component.label}
          InputProps={{
            startAdornment: getEditIcon(),
          }}
        />
      )}
      <FonctionPopperDefinition
        anchorEl={anchorEl}
        nom={component.nom}
        currentTags={component.functionTags}
        open={open}
        classes={classes}
        setAnchorEl={setAnchorEl}
        line={line}
        fonctionParams={tmpValue}
        setFonctionParams={handleChange}
      />
    </>
  )
}
